import React from 'react';

import { readCMSValue, getDefault } from 'modules/shared-cms/utils';
import { AdvantageContainer, MentionContainer } from 'modules/shared-cms-advanced/components';

import { CatalogueAdvantageProps } from '.';

export const CatalogueAdvantage: React.FC<CatalogueAdvantageProps> = ({
    signId,
    cmsSignData,
    cmsBrandData,
    cmsBrandCorner,
    secondaryTitle,
    textStyle,
    containerClassName,
    innerContainerClassName,
}: CatalogueAdvantageProps) => {
    const unwrappedCorner = cmsBrandCorner && cmsBrandCorner.length > 0 ? cmsBrandCorner[0] : undefined;
    const unwrappedBrandAdvantage = cmsBrandData && cmsBrandData.length > 0 ? cmsBrandData[0] : undefined;

    // Avantage enseigne disponible uniquement si le corner marque existe
    if (
        (!unwrappedCorner ||
            !unwrappedCorner.data ||
            !signId ||
            getDefault(readCMSValue(unwrappedCorner.data.signId), '') !== signId) &&
        !unwrappedBrandAdvantage
    ) {
        return <React.Fragment />;
    }

    const unwrappedSignAdvantage = cmsSignData && cmsSignData.length > 0 ? cmsSignData[0] : undefined;
    const advantage = unwrappedBrandAdvantage || unwrappedSignAdvantage;
    const advantageMentions = (unwrappedSignAdvantage || unwrappedBrandAdvantage || { data: { mention: '' } }).data
        .mention;
    const mentionFontSize =
        advantage && advantage.data ? getDefault(readCMSValue(advantage.data.mentionFontSize), 12) : 12;
    const titleStyle = {
        fontFamily: 'UrbanistMedium',
        fontSize: '1.4rem',
    };
    return (
        <React.Fragment>
            {advantage && (
                <AdvantageContainer
                    {...advantage.data}
                    secondaryTitle={secondaryTitle}
                    expander
                    titleStyle={titleStyle}
                    textStyle={textStyle}
                    containerClassName={containerClassName}
                    innerContainerClassName={innerContainerClassName}
                >
                    <MentionContainer
                        mention={advantageMentions}
                        mentionFontSize={mentionFontSize}
                        mentionTextColor="#646464"
                    />
                </AdvantageContainer>
            )}
        </React.Fragment>
    );
};
